<template>
  <div id="Index">
    <Hero>
      <h1>{{ $t('title') }}</h1>
    </Hero>
  </div>
</template>

<script>
import Hero from 'views/components/Hero'
import Meta from 'views/mixins/Meta'

export default {
  mixins: [
    Meta(),
  ],
  components: {
    Hero,
  },
}
</script>

<style lang="scss">
#Index {
  .Hero {
    background-color: transparent;
    color: $black;
    min-height: 80vh;
    text-align: center;

    .image img {
      filter: brightness(0.7);
    }

    .MainLogo {
      height: 10rem;
    }

    .Btn {
      display: inline-block;
      margin: 2rem auto;
      width: auto;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "meta": {
      "title": {
        "complement": "Homepage",
        "inner": "Nogrid",
        "separator": "|"
      }
    },
    "title": "Nogrid",
    "button": "Documentation"
  }
}
</i18n>
